import { useFeatureFlagEnabled, useFeatureFlagPayload as usePostHogFeatureFlagPayload } from '@posthog/react';

import type { FeatureFlag, FeatureFlagPayloadMap } from './use-feature-flag.type';

export const useFeatureFlag = (key: FeatureFlag): boolean => useFeatureFlagEnabled(key) ?? false;

/**
 * The flag's three states: `undefined` while PostHog has nothing stored, then the boolean. Until
 * `/flags` answers, that boolean is the one stored from the last session, so it may be stale.
 *
 * `useFeatureFlag` above collapses `undefined` into `false`, which is the right default for
 * DECIDING WHETHER TO SHOW something but wrong for anything that PERSISTS the answer: a write
 * during the load would be indistinguishable from a real `false`, and for anything that acts on a
 * `false` irreversibly, such as redirecting away from the invite link. `DevModeProvider` and
 * `CompanyClubProvider` (`add-organizer-to-venue`) are the only callers — gate features on `useFeatureFlag`.
 */
export const useFeatureFlagState = (key: FeatureFlag): boolean | undefined => useFeatureFlagEnabled(key);

export const useFeatureFlagPayload = <K extends FeatureFlag>(key: K): FeatureFlagPayloadMap[K] | undefined =>
  usePostHogFeatureFlagPayload(key) as FeatureFlagPayloadMap[K] | undefined;
